import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

const url = new URL(window.location.href);

if (
    !url.hostname.includes("localhost") &&
    url.pathname.includes("/wp-content/plugins/ibj-people/people/dist")
) {
    throw new Error("Not found.");
}

createApp(App).use(router).mount("#app");
